import React from 'react'
import { Row, Col } from 'reactstrap'
import ContactForm from './contact-form'
import MailchimpForm from './mailchimp-form'

const ContactUs = (props) => {

    return (

        <div>
        <Row>
            <div dangerouslySetInnerHTML={{__html:props.intro}} />
        </Row>
        <Row>
            <Col md="12" className="slidingPanelLeft" dangerouslySetInnerHTML={{__html:props.leftCol}} />
            <ContactForm />
            <MailchimpForm />
        </Row>
    </div>
    )

}

export default ContactUs



// WEBPACK FOOTER //
// ./src/components/contact-us.js